import React, { FC, SetStateAction } from 'react';
import { DatePicker, Toggle } from '@silverfort/sf-components';
import Collapse from '@material-ui/core/Collapse';
import moment, { Moment } from 'moment';
import RiskReportSettingsForm, { SettingsFormProps } from './RiskReportSettingsForm';

interface Props extends SettingsFormProps {
    setReportFromDate: React.Dispatch<SetStateAction<Moment | null>>;
    setReportToDate: React.Dispatch<SetStateAction<Moment | null>>;
    isAutomaticallyGenerated: boolean;
    setIsAutomaticallyGenerated: React.Dispatch<SetStateAction<boolean>>;
    reportFromDate: moment.Moment | null;
    reportToDate: moment.Moment | null;
}

const RiskReportContent: FC<Props> = ({
    reportFromDate,
    setReportFromDate,
    reportToDate,
    setReportToDate,
    isAutomaticallyGenerated,
    setIsAutomaticallyGenerated,
    ...SettingsFormProps
}) => {
    return (
        <div className="h-fit w-full flex flex-col gap-[24px]">
            <div className="flex flex-col gap-[16px]">
                <div className="text-black text-13 font-sf font-medium">Assessment Period</div>
                <div className="w-full h-fit p-[16px] rounded-lg border flex flex-1 items-center justify-between gap-2">
                    <DatePicker
                        value={reportFromDate}
                        onChange={(newValue) => setReportFromDate(newValue)}
                        maxDate={moment()}
                    />
                    <DatePicker
                        value={reportToDate}
                        onChange={(newValue) => setReportToDate(newValue)}
                        maxDate={moment()}
                    />
                </div>
            </div>
            <div className="flex gap-[8px]">
                <Toggle checked={isAutomaticallyGenerated} onChange={setIsAutomaticallyGenerated} />
                <div className="text-13 text-sf-gray-800 font-sf">Generate report automatically</div>
            </div>
            <Collapse in={isAutomaticallyGenerated}>
                <div className="w-full flex flex-col gap-[8px]">
                    <div className="text-black text-13 font-sf font-medium">Select time & frequency</div>
                    <RiskReportSettingsForm {...SettingsFormProps} />
                </div>
            </Collapse>
        </div>
    );
};

export default RiskReportContent;
